//= require ./directives
import angular from 'angular';

class EmailFormController {
  onChangeSelectedAdmin: ($args: { $id: number }) => void;
  onMessageUpdate: ($args: { $message: string }) => void;
  message: string;

  handleAdminSelect($id: number): void {
    this.onChangeSelectedAdmin({ $id });
  }

  messageChanged() {
    this.onMessageUpdate({ $message: this.message });
  }
}

const EmailForm: angular.IComponentOptions = {
  template: `
    <div class="form-email-an-admin">
      <div class="form-group">
        <label class="input-label" for="adminEmails">Admins</label>
        <div class="btn-group admin-email-dropdown" uib-dropdown is-open="status.isopen">
          <button id="selected-admin-btn" type="button" class="form-control form-control-block form-control-sm" uib-dropdown-toggle>
            {{ ctrl.selectedAdmin.name }}
          </button>
          <ul class="dropdown-menu admin-emails-ul" uib-dropdown-menu role="menu" aria-labelledby="selected-admin-btn">
            <li ng-repeat="admin in ctrl.adminList" role="menuitem" ng-click="ctrl.handleAdminSelect(admin.id)">
              {{ admin.name }}
            </li>
          </ul>
        </div>
      </div>
      <div class="form-group">
        <label class="input-label" for="msgForAdmin">Message</label>
        <textarea name="email-message-input" class="form-control msg-for-admin" ng-model="ctrl.message" ng-change="ctrl.messageChanged()"></textarea>
      </div>
    </div>
  `,
  bindings: {
    adminList: '<',
    message: '<',
    onMessageUpdate: '&',
    onChangeSelectedAdmin: '&',
    selectedAdmin: '<',
  },
  controller: EmailFormController,
  controllerAs: 'ctrl',
};

angular.module('mode.components').component('emailForm', EmailForm);
